export default __webpack_public_path__ + "static/media/regulatory--bicycles-wrong-way--g1.135ae71c.png";